var _this = this;
import * as tslib_1 from "tslib";
import { settings } from '../../../settings';
import { RoutingActionTypes } from './types';
import Routing from 'fos-routing';
import FormDataRouteCreator from '../../util/FormDataRouteCreator';
import { LturRouter } from '../../util/routing/Router';
import { AppActionTypes } from '../../store/app/types';
import { ProductTypeHelper, store } from '../../../index';
export default Routing;
var assetsBaseUrl = settings.webApiHost;
export var getFosRoutes = function () {
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var websiteState, protocol, resultRoutingAction, res, routingData, _a, error_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    websiteState = getState().websiteState;
                    protocol = websiteState && websiteState.app && websiteState.app.location ? websiteState.app.location.protocol : 'https';
                    resultRoutingAction = {
                        type: RoutingActionTypes.RECEIVE_FOS_ROUTES,
                        fos_router: null
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch(protocol + '//' + assetsBaseUrl + settings.routesUrl)];
                case 2:
                    res = _b.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    routingData = _b.sent();
                    Routing.setData(routingData);
                    _a = resultRoutingAction;
                    return [4 /*yield*/, Routing];
                case 4:
                    _a.fos_router = _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, dispatch(resultRoutingAction)];
            }
        });
    }); };
};
export var createRouteSlugMap = function (flatProductGroups, location) {
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var routeMap, routeGroupIdMaps, resultRoutingAction, productType, productGroupValue, productGroupIdAction;
        return tslib_1.__generator(this, function (_a) {
            routeMap = FormDataRouteCreator.createRouteMap(flatProductGroups);
            routeGroupIdMaps = routeMap.routeGroupIdMaps;
            resultRoutingAction = {
                type: RoutingActionTypes.CREATE_ROUTE_SLUGS,
                routeSlugMap: routeMap.groupIdRouteMap,
                routeSlugGroupIdMaps: routeMap.routeGroupIdMaps
            };
            productType = store.getState().websiteState.app.url.context.productType;
            productGroupValue = LturRouter.getProductGroupId(location, routeGroupIdMaps[ProductTypeHelper.mapToCoreStateGroup(productType)]);
            if (productGroupValue) {
                productGroupIdAction = {
                    type: AppActionTypes.SET_URL_PRODUCT_GROUP_ID,
                    productGroupId: productGroupValue
                };
                dispatch(productGroupIdAction);
            }
            return [2 /*return*/, dispatch(resultRoutingAction)];
        });
    }); };
};
